var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    stroke: "#1F3645",
    strokeWidth: 1.1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.214,
    cy: 7.906,
    r: 3.594
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.214.719a7.187 7.187 0 017.188 7.187c0 3.265-4.863 11.452-6.589 14.054a.719.719 0 01-1.198 0C4.89 19.358.027 11.171.027 7.906A7.187 7.187 0 017.214.72z"
  }))));
}
export default SvgMarker;